// @flow
import { useContext } from 'react';

import { getIfAdvancedSecurityIsEnabled, getIfCustomDiscountsEnabled } from '../common-utils/utils';
import { IS_ADVANCED_SECURITY_LIVE_IN_CE1, RATE_CARD_BACKEND_NAME } from '../constants';
import { EstimateContext } from '../contexts/EstimateContext';
import { useGetAdvancedSecurityConfigurationQuery } from '../service-definitions/estimates';
import { transformAdvancedSecurityConfigurationResponseToFormValue } from '../components/advanced-security/utils';

/**
 * Fetches the estimate's Advanced Security tier config — only when the feature is live and both the
 * Advanced Security and Custom Discounts toggles are on — and returns it as the Formik value for the
 * advanced_security_custom_discounts_json field.
 *
 * @returns {Object} `{}` when unconfigured or not applicable, else `{ tiers: [{ end?, usage_percentage }] }`.
 */
export const useAdvancedSecurityConfiguration = () => {
  const estimate = useContext(EstimateContext);
  const estimateInputs = estimate?.inputs;

  const isAdvancedSecurityConfigurationApplicable =
    IS_ADVANCED_SECURITY_LIVE_IN_CE1 &&
    getIfAdvancedSecurityIsEnabled(estimateInputs) &&
    getIfCustomDiscountsEnabled(estimateInputs);

  const { data: advancedSecurityConfiguration } = useGetAdvancedSecurityConfigurationQuery(
    { estimateId: estimateInputs?.id, rateCardVersion: estimateInputs?.[RATE_CARD_BACKEND_NAME] },
    { skip: !isAdvancedSecurityConfigurationApplicable }
  );

  return transformAdvancedSecurityConfigurationResponseToFormValue(advancedSecurityConfiguration);
};
